/* st-reviews.core.js — reine Funktionen, Browser + Node (UMD). Keine DOM-Abhaengigkeit.
   Spec: docs/superpowers/specs/2026-08-03-st-reviews-design.md
   Wird von st-reviews.js (Frontend) und vom Backend-Endpoint gemeinsam genutzt,
   damit Formularpruefung vorne und hinten identisch ist. */
(function (root, factory) {
  var api = factory();
  if (typeof module !== 'undefined' && module.exports) { module.exports = api; }
  else { root.STReviewsCore = api; }
})(typeof self !== 'undefined' ? self : this, function () {
  'use strict';

  var MAX_BODY = 2000;
  var MAX_TITLE = 120;
  var MAX_NAME = 60;
  var MAX_FILES = 3;
  var MAX_IMAGE_BYTES = 10 * 1024 * 1024;    // 10 MB
  var MAX_VIDEO_BYTES = 100 * 1024 * 1024;   // 100 MB
  var IMAGE_TYPES = ['image/jpeg', 'image/png', 'image/webp'];
  var VIDEO_TYPES = ['video/mp4', 'video/quicktime'];

  function toRating(value) {
    var n = parseInt(value, 10);
    return (isFinite(n) && n >= 1 && n <= 5) ? n : null;
  }

  // Bewertungen -> {count, average, distribution}. Nur status 'published' zaehlt.
  function computeStats(reviews) {
    var dist = { 1: 0, 2: 0, 3: 0, 4: 0, 5: 0 };
    var sum = 0, count = 0;

    if (Object.prototype.toString.call(reviews) === '[object Array]') {
      for (var i = 0; i < reviews.length; i++) {
        var r = reviews[i];
        if (!r || r.status !== 'published') continue;
        var rating = toRating(r.rating);
        if (rating === null) continue;
        dist[rating]++;
        sum += rating;
        count++;
      }
    }

    return {
      count: count,
      average: count ? Math.round((sum / count) * 100) / 100 : null,
      distribution: dist
    };
  }

  // 4.67 -> "4,7" (deutsche Schreibweise, eine Nachkommastelle)
  function formatAverage(average) {
    if (typeof average !== 'number' || !isFinite(average)) return '';
    return average.toFixed(1).replace('.', ',');
  }

  // Durchschnitt -> Fuellgrad der 5 Sterne, je 0..1 (fuer Teilfuellung per CSS)
  function starFills(average) {
    var value = (typeof average === 'number' && isFinite(average)) ? average : 0;
    if (value < 0) value = 0;
    if (value > 5) value = 5;

    var fills = [];
    for (var i = 0; i < 5; i++) {
      var fill = value - i;
      if (fill < 0) fill = 0;
      if (fill > 1) fill = 1;
      fills.push(Math.round(fill * 100) / 100);
    }
    return fills;
  }

  function isBlank(value) {
    return typeof value !== 'string' || value.trim() === '';
  }

  // Formulareingabe -> {valid, errors}. errors ist ein Objekt feld -> Meldung.
  function validateSubmission(input) {
    var data = input || {};
    var errors = {};

    if (toRating(data.rating) === null) {
      errors.rating = 'Bitte vergeben Sie eine Bewertung von 1 bis 5 Sternen.';
    }

    if (isBlank(data.authorName)) {
      errors.authorName = 'Bitte geben Sie einen Anzeigenamen an.';
    } else if (data.authorName.trim().length > MAX_NAME) {
      errors.authorName = 'Der Anzeigename darf höchstens ' + MAX_NAME + ' Zeichen lang sein.';
    }

    if (typeof data.title === 'string' && data.title.trim().length > MAX_TITLE) {
      errors.title = 'Die Überschrift darf höchstens ' + MAX_TITLE + ' Zeichen lang sein.';
    }

    if (typeof data.body === 'string' && data.body.length > MAX_BODY) {
      errors.body = 'Der Text darf höchstens ' + MAX_BODY + ' Zeichen lang sein.';
    }

    if (data.consent !== true) {
      errors.consent = 'Bitte stimmen Sie der Veröffentlichung zu, damit wir Ihre Bewertung zeigen dürfen.';
    }

    var valid = true;
    for (var key in errors) { if (errors.hasOwnProperty(key)) { valid = false; break; } }
    return { valid: valid, errors: errors };
  }

  function indexOf(list, value) {
    for (var i = 0; i < list.length; i++) { if (list[i] === value) return i; }
    return -1;
  }

  function megabytes(bytes) {
    return Math.round(bytes / (1024 * 1024));
  }

  // Dateiliste -> {valid, errors}. errors ist eine Liste von Meldungen.
  function validateFiles(files) {
    var list = (Object.prototype.toString.call(files) === '[object Array]') ? files : [];
    var errors = [];

    if (list.length > MAX_FILES) {
      errors.push('Bitte laden Sie höchstens ' + MAX_FILES + ' Dateien hoch.');
      return { valid: false, errors: errors };
    }

    for (var i = 0; i < list.length; i++) {
      var file = list[i] || {};
      var name = file.name || 'Datei';
      var isImage = indexOf(IMAGE_TYPES, file.type) !== -1;
      var isVideo = indexOf(VIDEO_TYPES, file.type) !== -1;

      if (!isImage && !isVideo) {
        errors.push('„' + name + '" hat ein nicht unterstütztes Format. Erlaubt sind JPG, PNG, WEBP, MP4 und MOV.');
        continue;
      }

      var limit = isImage ? MAX_IMAGE_BYTES : MAX_VIDEO_BYTES;
      if (typeof file.size === 'number' && file.size > limit) {
        errors.push('„' + name + '" ist zu groß (max. ' + megabytes(limit) + ' MB).');
      }
    }

    return { valid: errors.length === 0, errors: errors };
  }

  // "Liebe {{vorname}}" + {vorname:"Maria"} -> "Liebe Maria".
  // Unbekannte Platzhalter werden entfernt; eingesetzte Werte werden nicht erneut ersetzt.
  function renderTemplate(text, vars) {
    if (typeof text !== 'string' || text === '') return '';
    var data = vars || {};
    return text.replace(/\{\{\s*([\w.-]+)\s*\}\}/g, function (_match, key) {
      var value = data[key];
      return (value === undefined || value === null) ? '' : String(value);
    });
  }

  // "Maria Thaler" -> "Maria T." (Vorschlag zur Datenminimierung im Formular)
  function maskAuthorName(name) {
    if (typeof name !== 'string') return '';
    var parts = name.trim().split(/\s+/);
    if (parts.length === 0 || parts[0] === '') return '';
    if (parts.length === 1) return parts[0];
    return parts[0] + ' ' + parts[parts.length - 1].charAt(0).toUpperCase() + '.';
  }

  return {
    computeStats: computeStats,
    formatAverage: formatAverage,
    starFills: starFills,
    validateSubmission: validateSubmission,
    validateFiles: validateFiles,
    renderTemplate: renderTemplate,
    maskAuthorName: maskAuthorName,
    limits: {
      MAX_BODY: MAX_BODY,
      MAX_TITLE: MAX_TITLE,
      MAX_NAME: MAX_NAME,
      MAX_FILES: MAX_FILES,
      MAX_IMAGE_BYTES: MAX_IMAGE_BYTES,
      MAX_VIDEO_BYTES: MAX_VIDEO_BYTES,
      IMAGE_TYPES: IMAGE_TYPES,
      VIDEO_TYPES: VIDEO_TYPES
    }
  };
});
